module.exports = __webpack_public_path__ + "static/agatawork2-94d7c41a287fc343c599fcd19ce8f9f4.jpg";